import {
  Badge,
  Box,
  Button,
  CardActionArea,
  CircularProgress,
  Dialog,
  Grid,
  Stack,
  Table,
  TableBody,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Loading from 'assets/images/loading.png';
import { MakeOfferLabel, OfferLeftTime } from './MarketplaceMakeoffer';
import { ExpandLessOutlined, HighlightOff } from '@mui/icons-material';
import { ToggleOff } from 'component/ContactTab/ContactTab';
import moment from 'moment';
import {
  getApiCall,
  getlistMakeOffer,
  offerWithdrawFunc,
  postApiCall,
} from 'api/apiService';
import { DELETE_AUTO_OFFER, GET_BUYER_MANAGEOFFER } from 'constant/app.config';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { poppins400, poppins500, poppins700 } from 'theme/common.style';
import MakeOffersNewPopup from './MakeOffersNewPopup';
import Swal from 'sweetalert2';
import { LockIconSharePage } from './Marketplaceicons';
import AiBannerStar from 'assets/svg/AiBannerStar.svg';
import ToggleOnn from 'assets/images/RadioButton.png';
import RestoreRoundedIcon from '@mui/icons-material/RestoreRounded';
import CampaignRestrictedPopup from './CampaignRestrictedPopup';
import NameTooltip from 'component/Common/NameTooltip';

const OffersGraphIcon = ({ matchessm }) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66515 15.8889C4.00959 15.8889 5.10959 14.7889 5.10959 13.4444C5.10959 12.8333 4.86515 12.2222 4.49848 11.8556L6.08737 8.55556H6.33181C6.94292 8.55556 7.55404 8.31111 7.9207 7.94444L11.2207 9.65555V9.77778C11.2207 11.1222 12.3207 12.2222 13.6651 12.2222C15.0096 12.2222 16.1096 11.1222 16.1096 9.77778C16.1096 9.16667 15.8651 8.67778 15.4985 8.18889L17.0874 4.88889H17.3318C18.6763 4.88889 19.7763 3.78889 19.7763 2.44444C19.7763 1.1 18.6763 0 17.3318 0C15.9874 0 14.8874 1.1 14.8874 2.44444C14.8874 3.05556 15.1318 3.66667 15.4985 4.03333L13.9096 7.33333H13.6651C13.054 7.33333 12.4429 7.57778 12.0763 7.94444L8.77626 6.35556V6.11111C8.77626 4.76667 7.67626 3.66667 6.33181 3.66667C4.98737 3.66667 3.88737 4.76667 3.88737 6.11111C3.88737 6.72222 4.13181 7.33333 4.49848 7.7L2.90959 11H2.66515C1.3207 11 0.220703 12.1 0.220703 13.4444C0.220703 14.7889 1.3207 15.8889 2.66515 15.8889Z"
        fill="#0065FC"
      />
    </svg>
  );
};
const BuyerhighestOffBadge = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0 }}
    >
      <g clip-path="url(#clip0_30764_192193)">
        <path
          d="M17.9487 14.7662L14.657 8.67878C14.9928 7.91659 15.1807 7.07425 15.1807 6.18803C15.1807 2.77253 12.4118 0.00390625 8.99655 0.00390625C5.58049 0.00390625 2.81186 2.77281 2.81186 6.18803C2.81186 7.09562 3.00902 7.95681 3.36002 8.73306L0.0536429 14.7633C-0.0529685 14.9571 -0.0352497 15.1962 0.0980628 15.3731C0.231657 15.5495 0.457219 15.6324 0.672639 15.5818L3.49611 14.9341L4.46248 17.6256C4.53786 17.8349 4.72883 17.98 4.95017 17.9963C4.96453 17.9975 4.9783 17.998 4.9918 17.998C5.09351 17.998 5.1933 17.9704 5.28057 17.9181C5.36783 17.8659 5.4393 17.7909 5.48736 17.7013L8.36483 12.3404C8.57462 12.3617 8.78536 12.3723 8.99623 12.3722C9.1917 12.3722 9.38462 12.3621 9.57531 12.3441L12.5152 17.7055C12.5672 17.8006 12.6456 17.8786 12.7409 17.9301C12.8362 17.9816 12.9444 18.0045 13.0524 17.996C13.2732 17.9783 13.4633 17.8335 13.5381 17.6254L14.5045 14.9338L17.3279 15.5815C17.5445 15.6338 17.7678 15.5497 17.9014 15.3739C18.0356 15.1984 18.0536 14.9605 17.9487 14.7662H17.9487ZM5.09414 16.056L4.38648 14.0844C4.28972 13.8164 4.00906 13.6603 3.73116 13.7264L1.64288 14.2053L4.02314 9.86395C4.80698 10.9229 5.92073 11.7216 7.21251 12.1103L5.09414 16.056ZM3.94184 6.18801C3.94184 3.40111 6.20957 1.13367 8.99674 1.13367C11.7836 1.13367 14.0511 3.40111 14.0511 6.18801C14.0511 8.97492 11.7836 11.2429 8.99674 11.2429C6.20927 11.2429 3.94184 8.97492 3.94184 6.18801ZM14.2693 13.7263C13.9903 13.6605 13.7108 13.8163 13.614 14.0844L12.9016 16.0703L10.7368 12.1229C12.0629 11.7345 13.2037 10.9147 13.9976 9.82484L16.368 14.2076L14.2693 13.7263Z"
          fill="black"
        />
        <path
          d="M9.0013 8.85286V3.70703L8.1888 4.10286M9.0013 8.85286H10.0846M9.0013 8.85286H7.91797"
          stroke="#171717"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_30764_192193">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const TrophyIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5842 12.9359C13.9042 11.9239 15.8402 10.4279 15.8402 4.8399V4.3999H6.16016V4.8399C6.16016 10.4279 8.14016 11.9239 9.41616 12.9359C10.1642 13.5079 10.5602 13.8159 10.5602 14.5199V15.8399C9.85616 15.9279 9.15216 16.1919 8.88816 16.7199H7.92016C7.43616 16.7199 7.04016 17.1159 7.04016 17.5999H14.9602C14.9602 17.1159 14.5642 16.7199 14.0802 16.7199H13.1122C12.8482 16.1919 12.1882 15.9279 11.4402 15.8399V14.5199C11.4402 13.8159 11.7922 13.5079 12.5842 12.9359ZM11.0002 13.1559C10.7362 12.8039 10.3402 12.4959 9.98816 12.2319C8.80016 11.3079 7.17216 10.0759 7.08416 5.2799H15.0042C14.9162 10.0319 13.2882 11.3079 12.1002 12.2319C11.6602 12.5399 11.2642 12.8039 11.0002 13.1559Z"
        fill="#2F3F5E"
      />
      <path
        d="M8.27153 11.8798C8.22753 11.8798 3.51953 10.8678 3.51953 5.71979V5.27979H6.59953V6.15979H4.39953C4.66353 10.2078 8.40353 10.9998 8.44753 10.9998L8.27153 11.8798Z"
        fill="#2F3F5E"
      />
      <path
        d="M13.7268 11.8798L13.5508 10.9998C13.7268 10.9558 17.3348 10.1638 17.5988 6.15979H15.3988V5.27979H18.4788V5.71979C18.4788 10.8678 13.7708 11.8798 13.7268 11.8798Z"
        fill="#2F3F5E"
      />
    </svg>
  );
};
const AiInfoIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
        fill="#2196F3"
      />
      <path
        d="M8.14062 8.14453H9.85491V12.8588H8.14062V8.14453Z"
        fill="white"
      />
      <path
        d="M8.99721 6.8577C9.58894 6.8577 10.0686 6.37801 10.0686 5.78627C10.0686 5.19454 9.58894 4.71484 8.99721 4.71484C8.40548 4.71484 7.92578 5.19454 7.92578 5.78627C7.92578 6.37801 8.40548 6.8577 8.99721 6.8577Z"
        fill="white"
      />
    </svg>
  );
};
const DessendingOrderIcon = ({ isSortedAscending }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_35101_146835)">
        <path
          d="M10.082 5.5H18.332"
          stroke={isSortedAscending ? 'gray' : '#0065FC'}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.082 11H18.332"
          stroke={isSortedAscending ? 'gray' : '#0065FC'}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 16.5H18.3333"
          stroke={isSortedAscending ? 'gray' : '#0065FC'}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.66797 14.6654C3.66797 14.1791 3.86112 13.7128 4.20494 13.369C4.54876 13.0252 5.01507 12.832 5.5013 12.832C5.98753 12.832 6.45385 13.0252 6.79766 13.369C7.14148 13.7128 7.33464 14.1791 7.33464 14.6654C7.33464 15.2071 6.8763 15.582 6.41797 16.0404L3.66797 18.332H7.33464"
          stroke={isSortedAscending ? 'gray' : '#0065FC'}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.5013 9.16797V3.66797L3.66797 5.5013"
          stroke={isSortedAscending ? 'gray' : '#0065FC'}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_35101_146835">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const BuyerhighestOffPin = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_30801_192238)">
        <path
          d="M11.8748 3.5625L8.70817 6.72917L5.5415 7.91667L4.354 9.10417L9.89567 14.6458L11.0832 13.4583L12.2707 10.2917L15.4373 7.125"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.125 11.875L3.5625 15.4375"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.479 3.16797L15.8332 7.52214"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_30801_192238">
          <rect width="19" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Pendingwarning = () => {
  return (
    <svg
      width="38"
      height="36"
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37.5797"
        height="36"
        rx="18"
        fill="#F39800"
        fill-opacity="0.1"
      />
      <path
        d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
        fill="#F39800"
      />
    </svg>
  );
};

const WarningIcon = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4901 11.4607L11.5789 1.45599C11.0462 0.555115 10.0621 0 8.99672 0C7.9314 0 6.94728 0.555115 6.41462 1.45599L0.399495 11.632C-0.133165 12.5329 -0.133165 13.6431 0.399495 14.544C0.932154 15.4449 1.91628 16 2.9816 16H15.0119C15.0152 16 15.0184 16 15.0184 16C16.6651 16 18 14.6962 18 13.088C18 12.4853 17.8116 11.9239 17.4901 11.4607ZM10.2732 12.4345C10.2732 13.1229 9.73078 13.6495 9 13.6495C8.26922 13.6495 7.72681 13.1229 7.72681 12.4345V12.406C7.72681 11.7208 8.26922 11.1911 9 11.1911C9.73078 11.1911 10.2732 11.7177 10.2732 12.406V12.4345ZM10.3024 4.24425L9.67232 9.61776C9.6301 10.0048 9.36702 10.2458 9 10.2458C8.63298 10.2458 8.3699 10.0016 8.32768 9.61776L7.69758 4.24108C7.65536 3.82554 7.88599 3.5115 8.28221 3.5115H9.71454C10.1108 3.51467 10.3446 3.82871 10.3024 4.24425Z"
        fill="#f39800"
      />
    </svg>
  );
};

const OffersSection = (props) => {
  const {
    lastHighestOffers,
    setLastHighestOffers,
    tabData,
    offerHistoryState,
    sharedpage,
    getBuyerIndividualValue,
    // getlistMakeOffer,
    withdrawLeftCount,
    stage,
    openlogin,
    groupCall,
    groupIt,
    setOpenlogin,
    isFocusMode,
    offersOnly,
    setOffersOnly,
    setGraphAction,
    graphAction,
    setTotalAmount,
    setMaximumOffer,
    setOfferIncreament,
    isConditionalChanceCompleted,
    lastLatestOffer,
    showResentOffer,
    setShowResentOffer,
  } = props;
  const agentBuyerBinderId =
    getBuyerIndividualValue?.PropertyDetails?.agentBuyerBinderId;
  const theme = useTheme();
  const params = useParams();
  const targetToScrollListingRef = useRef(null);
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches380 = useMediaQuery(theme.breakpoints.down(380));
  const matches1100 = useMediaQuery(theme.breakpoints.down(1100));
  const matches1280 = useMediaQuery(theme.breakpoints.down(1280));
  const isXsScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const data1 = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data1);

  const [isSorted, setIsSorted] = useState(false);
  const [isSortedAscending, setIsSortedAscending] = useState(false);
  const [offerSummary, setOfferSummary] = useState(false);
  const [indexs, setIndexs] = useState(-1);
  const [showpopup, setShowpopup] = useState(false);
  const [vendorCounterOffer, setVendorCounterOffer] = useState(false);
  const [vendorCounterOfferValue, setVendorCounterOfferValue] = useState('');
  const [manageOfferData, setManageOfferData] = useState([]);
  const [openWithdraw, setOpenWithdraw] = useState(false);
  const [openWithdrawLoader, setOpenWithdrawLoader] = useState(false);
  const [withdrawOfferUniqueId, setWithdrawOfferUniqueId] = useState('');
  const [withdrawOfferamount, setWithdrawOfferamount] = useState('');
  const [isThisAutoOffer, setIsThisAutoOffer] = useState('');

  const isRequestAccessLock =
    (getBuyerIndividualValue?.PropertyDetails?.stage == 'ST2' &&
    getBuyerIndividualValue?.PropertyDetails?.isStageTwo == '0'
      ? true
      : false) &&
    getBuyerIndividualValue?.PropertyDetails?.timerStatus != 'Pause' &&
    getBuyerIndividualValue?.PropertyDetails?.campaignType != 'Auction' &&
    getBuyerIndividualValue?.PropertyDetails?.isWinner != '1' &&
    !sharedpage;

  useEffect(() => {
    if (openWithdrawLoader) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [openWithdrawLoader]);

  let filterData;

  let propertyId = params?.propertyId;

  useEffect(() => {
    const isSharePage = window.location.pathname.includes('/share/');

    if (!isSharePage) {
      getApiCall(GET_BUYER_MANAGEOFFER + `/${propertyId}`).then(async (res) => {
        if (res?.status === 200) {
          setManageOfferData(res?.data);
        }
      });
    }
  }, [lastHighestOffers]);

  useEffect(() => {
    groupCall();
  }, []);

  const handleLatestOffers = () => {
    setShowResentOffer(false);
  };

  const sortedHighestOffers = useMemo(() => {
    if (!lastHighestOffers || lastHighestOffers.length === 0) return [];

    return [...lastHighestOffers].sort(
      (a, b) =>
        parseFloat(b.offerPrice.replace(/[^0-9.-]+/g, '')) -
        parseFloat(a.offerPrice.replace(/[^0-9.-]+/g, ''))
    );
  }, [lastHighestOffers]); // Only re-runs when lastHighestOffers changes

  let buyerOffers = showResentOffer ? lastLatestOffer : lastHighestOffers;
  const [openCampaignRestrictedPopup, setOpenCampaignRestrictedPopup] =
    useState(false);

  const makeOfferGraphAction = () => {
    setGraphAction(true);
  };

  const handleMakeThisOffer = (price) => {
    const validPrice =
      typeof price === 'number' ? price : parseFloat(price.replace(/,/g, ''));
    setTotalAmount(validPrice);
  };
  //  !!this filter logic(1) write two times for diff senario
  const filterFunction = () => {
    // if (lastHighestOffers?.length > 0) {
    setOffersOnly(!offersOnly);
    if (!offersOnly) {
      const filterData = lastHighestOffers?.filter(
        (item) => item?.propertyOfferBuyerId === userDetail?.userId
      );
      setLastHighestOffers(filterData);
    } else {
      getlistMakeOffer(
        propertyId,
        window.location.pathname,
        userDetail?.primaryUserType
      ).then((res) => {
        if (res?.status == 1) {
          setLastHighestOffers(res?.LastHighestOffers);
        }
      });
    }
  };
  // !!this filter logic(2)
  // My offers only toggle is on, withdrawn completed filter run again

  const refreshLastHighestOffers = () => {
    if (offersOnly) {
      setLastHighestOffers((prev) =>
        prev?.filter(
          (item) => item?.propertyOfferBuyerId === userDetail?.userId
        )
      );
    } else {
      getlistMakeOffer(
        propertyId,
        window.location.pathname,
        userDetail?.primaryUserType
      ).then((res) => {
        if (res?.status === 1) {
          setLastHighestOffers(res?.LastHighestOffers);
        }
      });
    }
  };

  //  useEffect(() => { if (offersOnly) { const filtered = lastHighestOffers?.filter( (item) => item?.propertyOfferBuyerId == userDetail?.userId ); setLastHighestOffers(filtered); } }, [offersOnly, lastHighestOffers, userDetail?.userId]);
  useEffect(() => {
    if (offersOnly && lastHighestOffers?.length) {
      const filtered = lastHighestOffers.filter(
        (item) => item?.propertyOfferBuyerId == userDetail?.userId
      );
      // Only set if changed
      if (filtered.length !== lastHighestOffers.length) {
        setLastHighestOffers(filtered);
      }
    }
  }, [offersOnly, userDetail?.userId, lastHighestOffers]);

  const handleScrollToTopListing = () => {
    if (targetToScrollListingRef.current) {
      targetToScrollListingRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const showOfferSummary = (event) => {
    event.stopPropagation();
    setOfferSummary(true);
  };

  const offerSetFunc = (offerUniqueId, offeramount, isAutoOfferConfirm) => {
    setOpenWithdraw(true);
    setWithdrawOfferUniqueId(offerUniqueId);
    setWithdrawOfferamount(offeramount);
    setIsThisAutoOffer(isAutoOfferConfirm);
  };

  const buyerId = Number(userDetail?.userId);
  const DeleteAutoOfferSummary = async () => {
    const data = {
      propertyId:
        getBuyerIndividualValue?.PropertyDetails?.property?.propertyId,
      buyerId: buyerId,
    };
    try {
      await postApiCall(DELETE_AUTO_OFFER, data);
    } catch (error) {
      console.error('API Error:', error);
    }
  };

  useEffect(() => {
    if (offersOnly) {
      filterFunction();
    }
    if (isFocusMode) {
      setOffersOnly(false);
    }
  }, [isFocusMode]);

  const withdrawFunc = async () => {
    try {
      setOpenWithdrawLoader(true);
      const input = { offerUniqueId: withdrawOfferUniqueId };

      const res = await offerWithdrawFunc(input);

      if (res?.status == 1) {
        setOpenWithdraw(false);
        if (isThisAutoOffer == 1) {
          await DeleteAutoOfferSummary();
        }
        Swal.fire({
          title: res?.heading || 'Success',
          text: res?.message,
          icon: 'success',
          confirmButtonText: 'Close',
        });

        groupCall();
        groupIt();
      } else {
        Swal.fire({
          title: res?.heading || 'Error',
          text: res?.message,
          icon: 'error',
          confirmButtonText: 'Close',
        });
      }
    } catch (error) {
      console.error('Withdraw API Error:', error);
    } finally {
      setTimeout(() => {
        refreshLastHighestOffers();
      }, 2000);
      setOpenWithdrawLoader(false);
      setMaximumOffer('');
      setOfferIncreament('');
    }
  };

  return (
    <>
      <Stack
        sx={{
          display: 'flex',
          width: matches1100 ? '100%' : '50%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: matchessm ? 'start' : 'center',
            justifyContent: 'space-between',
            gap: matchessm ? '5px' : '10px',
            height: '50px',
          }}
        >
          <Typography
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: matchessm ? '0px' : '15px',
              fontFamily: 'Poppins !important',
              fontStyle: 'normal !important',
              fontWeight: '500 !important',
              fontSize: matchessm ? '20px' : '24px',
              color: '#000000',
              whiteSpace: 'nowrap',
            }}
            className="ddd"
          >
            <MakeOfferLabel sx={{ width: !isFocusMode && '157px' }}>
              {' '}
              {isFocusMode
                ? 'Offers'
                : showResentOffer || sharedpage
                ? 'Latest Offers'
                : 'Highest Offer'}
            </MakeOfferLabel>
            {((!sharedpage && offersOnly) || lastHighestOffers?.length > 0) && (
              <Box
                sx={{
                  display:
                    tabData == '4' && !offerHistoryState && matchessm
                      ? 'none'
                      : 'flex',
                  alignItems: 'center',
                  gap: matchessm ? '5px' : '10px',
                  paddingLeft: matches1280 ? 2 : 10,
                  marginTop: '5px',
                }}
              >
                {!showResentOffer ? (
                  <CardActionArea
                    onClick={() => {
                      setShowResentOffer(!showResentOffer);
                    }}
                    disabled={isRequestAccessLock}
                    sx={{
                      height: 42,
                      width: 42,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: '1px solid #E0E0E0',
                      borderRadius: '8px',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: '#F7F3FF',
                        borderColor: '#6C2AD2',
                      },
                    }}
                  >
                    <DessendingOrderIcon isSortedAscending={showResentOffer} />
                  </CardActionArea>
                ) : (
                  <Badge
                    variant="dot"
                    sx={{
                      '& .MuiBadge-dot': {
                        backgroundColor: '#FF0101',
                        marginTop: '7px',
                        marginRight: '6px',
                      },
                    }}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                  >
                    <CardActionArea
                      // onClick={() =>{ if (!showResentOffer){ handleLatestOffers()}}}
                      onClick={() => {
                        handleLatestOffers(!showResentOffer);
                      }}
                      // disableRipple={showResentOffer}
                      // disabled={showResentOffer}
                      sx={{
                        height: 42,
                        width: 42,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1px solid #E0E0E0',
                        borderRadius: '8px',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          backgroundColor: '#F7F3FF',
                          borderColor: '#6C2AD2',
                        },
                      }}
                    >
                      <RestoreRoundedIcon
                        fontSize="29px"
                        sx={{
                          // marginTop: 1,
                          color: !showResentOffer ? 'gray' : '#0065FC',
                        }}
                      />
                    </CardActionArea>
                  </Badge>
                )}
                {!graphAction && (
                  <CardActionArea
                    onClick={makeOfferGraphAction}
                    disabled={isRequestAccessLock}
                    sx={{
                      height: 42,
                      width: 42,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: '1px solid #E0E0E0',
                      borderRadius: '8px',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: '#F7F3FF',
                        borderColor: '#6C2AD2',
                      },
                    }}
                  >
                    <OffersGraphIcon />
                  </CardActionArea>
                )}
              </Box>
            )}
          </Typography>
          {((!sharedpage && offersOnly) || lastHighestOffers?.length > 0) && (
            <Box
              onClick={() => {
                if (isRequestAccessLock) return;
                filterFunction();
              }}
              sx={{
                display:
                  tabData == '4' && !offerHistoryState && matchessm
                    ? 'none'
                    : 'flex',
                flexDirection: matchessm ? 'column' : 'row',
                alignItems: 'center',
                border: !matchessm && '1px solid #F0F0F0',
                borderRadius: '5px',
                padding: matchessm ? '5px' : '10px',
                gap: matchessm ? '1px' : '15px',
                cursor: isRequestAccessLock ? 'default' : 'pointer',
                opacity: filterData?.length == 0 && 0.4,
                pointerEvents: filterData?.length == 0 && 'none',
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '10px' : '12px',
                  whiteSpace: 'nowrap',
                }}
              >
                My Offers Only
              </Typography>
              {!offersOnly ? (
                <ToggleOff />
              ) : (
                <img
                  src={ToggleOnn}
                  alt="Start"
                  style={{
                    height: matchessm ? '25px' : '',
                    width: matchessm ? '42px' : '',
                  }}
                />
              )}
            </Box>
          )}
        </Box>
        <Box
          ref={targetToScrollListingRef}
          sx={{
            overflowY:
              lastHighestOffers?.length > 3 && matchessm ? 'scroll' : 'hidden',
            overflowX: 'hidden',
            marginTop: matchessm && '-10px',
            height:
              sharedpage || (tabData == '4' && !offerHistoryState && matchessm)
                ? matchesmd
                  ? '350px'
                  : '580px'
                : lastHighestOffers?.length > 5 && !matchessm
                ? '580px'
                : lastHighestOffers?.length > 3 && matchessm
                ? '350px'
                : 'auto',
            position: 'relative',

            '&:hover': {
              // overflowY: "auto",
              overflowY: sharedpage ? 'hidden' : 'auto',
            },
            scrollbarWidth: matchessm ? 'none !important' : 'thin !important',
            '&::-webkit-scrollbar': {
              display: matchessm ? 'none !important' : 'flex !important',
              scrollbarWidth: matchessm ? 'none !important' : 'thin !important',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#888',
              borderRadius: '10px !important',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: '#f1f1f1',
            },
          }}
        >
          <Box
            sx={{
              position: 'relative',
              width: '100%',
            }}
          >
            {isRequestAccessLock && (
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  zIndex: 10,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <LockIconSharePage />
              </Box>
            )}
            <Table
              sx={{
                marginRight: '10px',
                marginTop: matchessm ? '12px' : '8px',
                paddingTop: '10px',
                filter: sharedpage && 'blur(8px)',
                opacity: sharedpage && '0.4',
                userSelect: sharedpage && 'none',
                pointerEvents: sharedpage && 'none',
                position: sharedpage && 'absolute',
                ...(isRequestAccessLock && {
                  filter: 'blur(3.5px)',
                  opacity: 0.4,
                  pointerEvents: 'none',
                  userSelect: 'none',
                  mt: 1,
                }),
              }}
            >
              <TableBody>
                {buyerOffers?.length > 0 ? (
                  <>
                    {(sharedpage ||
                    (tabData == '4' && !offerHistoryState && matchessm)
                      ? buyerOffers?.slice(0, 1)
                      : buyerOffers
                    )?.map((item, index) => {
                      const firstActiveIndex = buyerOffers?.findIndex(
                        (item) => item?.isActive != 0
                      );
                      const isConditionalChance = item?.isConditionalChance;
                      const createdAt = item?.createdAt;
                      const createdAtMoment = moment(
                        createdAt,
                        'YYYY-MM-DD HH:mm:ss'
                      );
                      const currentTime = new Date(
                        new Date().toLocaleString('en-US', {
                          timeZone: 'Australia/Sydney',
                        })
                      );
                      const timeDifference = currentTime - createdAtMoment;

                      let timeCorrected = '';
                      const oneDay = 24 * 60 * 60 * 1000;
                      const oneHour = 60 * 60 * 1000;
                      const oneMinute = 60 * 1000;

                      if (timeDifference < 0) {
                        timeCorrected = `1 second ago`;
                      } else if (timeDifference >= oneDay) {
                        const remainingDays = Math.floor(
                          timeDifference / oneDay
                        );
                        timeCorrected = `${remainingDays} ${
                          remainingDays < 2 ? 'day' : 'days'
                        }  ago`;
                      } else if (timeDifference >= oneHour) {
                        const remainingHours = Math.floor(
                          timeDifference / oneHour
                        );
                        timeCorrected = ` ${remainingHours} ${
                          remainingHours < 2 ? 'hour' : 'hours'
                        } ago`;
                      } else if (timeDifference >= oneMinute) {
                        const remainingMinutes = Math.floor(
                          timeDifference / oneMinute
                        );
                        timeCorrected = `${remainingMinutes}  ${
                          remainingMinutes < 2 ? 'minute' : 'minutes'
                        }  ago`;
                      } else {
                        const remainingSeconds = Math.floor(
                          timeDifference / 1000
                        );
                        timeCorrected = `${remainingSeconds}  ${
                          remainingSeconds < 2 ? 'second' : 'seconds'
                        } ago`;
                      }
                      return (
                        <TableRow
                          key={index}
                          sx={{
                            position:
                              index === 0 && matchessm ? 'sticky' : 'relative',
                            top: index === 0 && matchessm ? 0 : 'auto',
                            zIndex: index === 0 && matchessm ? 2 : 1,
                            backgroundColor:
                              index === 0 && matchessm
                                ? '#ffffff'
                                : 'rgba(255, 255, 255, 0.95)',
                            filter:
                              item?.isActive == 0 ||
                              item?.isConditionalChance == 1
                                ? 'blur(1px)'
                                : 'none',
                          }}
                        >
                          <Grid
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              cursor:
                                item?.isActive == 0 ? 'default' : 'pointer',
                              pointerEvents:
                                item?.isActive == 0 ? 'none' : 'auto',
                              minWidth: matchessm && '100%',
                              minHeight: '89px',
                              border:
                                index == firstActiveIndex
                                  ? '1px solid #6C2AD2'
                                  : item?.isCounter == 1 || item?.isPrivate == 1
                                  ? '1px solid #2F74EE'
                                  : '1px solid lightgrey',
                              marginTop: '12px',
                              borderRadius: '8px',
                              position: 'relative',
                              marginRight: '10px',
                              marginLeft: isFocusMode && '10px',
                              padding: '5px',
                              marginBottom: '15px',
                              background:
                                index == firstActiveIndex
                                  ? '#BBBBBB1A'
                                  : item?.isCounter == 1 || item?.isPrivate == 1
                                  ? '#2F74EE1A'
                                  : '#fff',
                            }}
                          >
                            <Grid
                              container
                              onClick={(event) => {
                                if (isConditionalChance == 1) {
                                  return;
                                } else if (
                                  item?.buyerUniqueId == userDetail?.userAppId
                                ) {
                                  item?.buyerUniqueId ==
                                    userDetail?.userAppId &&
                                    showOfferSummary(event);
                                  setIndexs(index);
                                  setShowpopup(true);
                                  setVendorCounterOffer(false);
                                } else {
                                  let uniqID =
                                    item?.buyerUniqueId !==
                                      userDetail?.userAppId ||
                                    item?.offerUniqueId !==
                                      userDetail?.userAppId;
                                  if (
                                    item?.isCounter !== 1 &&
                                    item?.isPrivate !== 1 &&
                                    uniqID
                                  ) {
                                    showOfferSummary(event);
                                    setIndexs(index);
                                    setShowpopup(false);
                                    setVendorCounterOffer(false);
                                    setVendorCounterOfferValue(item);
                                  } else {
                                    (item?.isCounter === 1 ||
                                      item?.isActive == 1) &&
                                      showOfferSummary(event);
                                    setIndexs(index);
                                    setShowpopup(true);
                                    setVendorCounterOffer(true);
                                    setVendorCounterOfferValue(item);
                                  }
                                }
                              }}
                              sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                // gap:matches500&&"15px",
                                margin: matchessm ? '0 0 0 10px' : '0 10px',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                cursor:
                                  item?.buyerUniqueId !==
                                    userDetail?.userAppId &&
                                  item?.offerUniqueId !==
                                    userDetail?.userAppId &&
                                  item?.isCounter !== 1 &&
                                  item?.isPrivate !== 1
                                    ? 'default'
                                    : item?.buyerUniqueId ===
                                        userDetail?.userAppId ||
                                      item?.isActive == 1 ||
                                      item?.isCounter == 1 ||
                                      item?.isPrivate == 1
                                    ? 'pointer'
                                    : 'default',
                              }}
                            >
                              <Grid
                                xs={isFocusMode ? 4 : 5}
                                item
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: '6px',
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontStyle: 'normal !important',
                                    fontWeight: '600 !important',
                                    fontSize: '20px',
                                    color: '#000000',
                                  }}
                                >
                                  <MakeOfferLabel>
                                    <Typography
                                      sx={{
                                        display: 'flex',
                                        whiteSpace: 'nowrap',
                                        fontFamily: 'poppins',
                                        fontSize: isFocusMode ? '14px' : '16px',
                                        fontWeight: 600,
                                      }}
                                    >
                                      {item?.propertyOfferBuyerId == '0' ? (
                                        <>
                                          <Typography
                                            sx={{
                                              display: 'flex',
                                              whiteSpace: 'nowrap',
                                              fontFamily: 'poppins',
                                              fontSize: isFocusMode
                                                ? '14px'
                                                : '20px',
                                              fontWeight: 600,
                                            }}
                                          >
                                            AiBuyerSuggest
                                          </Typography>
                                          <Typography
                                            sx={{ marginTop: '-9px' }}
                                          >
                                            <AiInfoIcon />
                                          </Typography>
                                          <Typography>
                                            <sup
                                              style={{
                                                position: 'absolute',
                                                top: matchessm ? '15px' : '0px',
                                              }}
                                            >
                                              <img
                                                src={AiBannerStar}
                                                alt="Start"
                                                style={{
                                                  // marginBottom: matchessm ? "10px" : "30px",
                                                  height: matchessm
                                                    ? '30px'
                                                    : '',
                                                  width: matchessm
                                                    ? '30px'
                                                    : '',
                                                }}
                                              />
                                            </sup>
                                          </Typography>
                                        </>
                                      ) : item?.isPrivate == 1 ? (
                                        'Vendor Private Offer'
                                      ) : item?.isCounter == 1 ? (
                                        'Vendor Counter Offer'
                                      ) : item?.propertyOfferBuyerId ===
                                        userDetail?.userId ? (
                                        <NameTooltip
                                          name={userDetail?.userName || ''}
                                          surname={
                                            userDetail?.userSurName || ''
                                          }
                                        >
                                          <Typography
                                            sx={{
                                              display: 'inline',
                                              fontFamily: 'poppins',
                                              fontSize: isFocusMode
                                                ? '14px'
                                                : '16px',
                                              fontWeight: 600,
                                              whiteSpace: 'nowrap',
                                            }}
                                          >
                                            {`${userDetail?.userName || ''} ${
                                              userDetail?.userSurName || ''
                                            }`.trim()}
                                          </Typography>
                                        </NameTooltip>
                                      ) : getBuyerIndividualValue
                                          ?.PropertyDetails?.stage == 'ST1' ? (
                                        item?.offerUniqueId + ' (Not You)'
                                      ) : (
                                        item?.buyerUniqueId + ' (Not You)'
                                      )}
                                      &nbsp;
                                      {isConditionalChance == 1 && (
                                        <Box
                                          component="span"
                                          sx={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            mt: '-7px',
                                          }}
                                          onClick={(event) => {
                                            event.stopPropagation();
                                            setOpenCampaignRestrictedPopup(
                                              true
                                            );
                                          }}
                                        >
                                          <AiInfoIcon />
                                        </Box>
                                      )}
                                      {index == firstActiveIndex &&
                                        item?.isWinner !== 1 &&
                                        item?.propertyOfferBuyerId !== 0 && (
                                          <BuyerhighestOffBadge />
                                        )}
                                      {/* item?.propertyOfferBuyerId ===
                                          userDetail?.userId - uncommented, because Trophy icon is shown for non-winners also */}
                                      {index == firstActiveIndex &&
                                        item?.propertyOfferBuyerId ===
                                          userDetail?.userId &&
                                        item?.isWinner == 1 && (
                                          <Typography>
                                            <TrophyIcon />
                                          </Typography>
                                        )}
                                    </Typography>
                                  </MakeOfferLabel>
                                </Typography>

                                <Typography
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '15px',
                                    fontFamily: 'Poppins !important',
                                    fontStyle: 'normal !important',
                                    fontWeight: '400 !important',
                                    fontSize: matchesmd ? '12px' : '16px',
                                    color: '#666666',
                                    whiteSpace: 'nowrap',
                                    width: 'min-content',
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      fontSize: isFocusMode ? '14px' : '16px',
                                      width: matchessm
                                        ? '125px'
                                        : 'min-content',
                                    }}
                                  >
                                    {item?.createdAt != null ? (
                                      timeCorrected
                                    ) : item?.propertyOfferBuyerId == '0' ? (
                                      <Typography
                                        onClick={() => {
                                          if (
                                            getBuyerIndividualValue
                                              ?.PropertyDetails?.timerStatus !==
                                            'End'
                                          ) {
                                            handleMakeThisOffer(
                                              item?.offerPrice.slice(1)
                                            );
                                          }
                                        }}
                                        sx={{
                                          fontFamily: 'poppins',
                                          fontWeight: 400,
                                          fontSize: '16px',
                                          cursor:
                                            getBuyerIndividualValue
                                              ?.PropertyDetails?.timerStatus ==
                                            'End'
                                              ? 'not-allowed'
                                              : 'pointer',
                                          color:
                                            getBuyerIndividualValue
                                              ?.PropertyDetails?.timerStatus ==
                                            'End'
                                              ? 'gray'
                                              : '#6C2AD2',
                                          ':hover': {
                                            textDecoration:
                                              getBuyerIndividualValue
                                                ?.PropertyDetails
                                                ?.timerStatus !== 'End' &&
                                              'underline',
                                          },
                                        }}
                                      >
                                        Make This Offer
                                      </Typography>
                                    ) : (
                                      ' '
                                    )}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      display: !matchessm ? 'none' : 'flex',
                                      flexDirection: 'column',
                                      gap: '6px',
                                    }}
                                  >
                                    {item?.isActive == 0 && (
                                      <Typography
                                        sx={{
                                          display: !matchessm && 'none',
                                          background: '#F939391A',
                                          color: '#F93939',
                                          borderRadius: '4px',
                                          fontSize: '12px',
                                          padding:
                                            item?.isConditional != 1
                                              ? '3px 15px'
                                              : '3px 8px',
                                          fontWeight: '600',
                                          fontFamily: 'poppins',
                                        }}
                                      >
                                        Withdrawn
                                      </Typography>
                                    )}
                                    <Typography
                                      sx={{
                                        display: !matchessm && 'none',
                                        background:
                                          item?.logIsConditional === 1 ||
                                          item?.isConditional == 1
                                            ? 'rgba(237, 11, 11, 0.6)'
                                            : 'rgba(16, 211, 94, 1)',
                                        color: 'white',
                                        borderRadius: '4px',
                                        fontSize: '10px',
                                        padding: '2px 7px',
                                        fontWeight: '500',
                                        fontFamily: 'poppins',
                                        visibility:
                                          item?.isPrivate == 1
                                            ? 'visible'
                                            : item?.buyerUniqueId ===
                                              userDetail?.userAppId
                                            ? 'visible'
                                            : 'hidden',
                                      }}
                                    >
                                      {item?.logIsConditional == 1 ||
                                      item?.isConditional == 1
                                        ? 'Conditional'
                                        : ' Unconditional'}
                                    </Typography>
                                  </Typography>
                                  {/* {"5 hours ago"} */}
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                sm={3}
                                sx={{
                                  display: matchessm ? 'none' : 'flex',
                                  flexDirection: 'column',
                                  marginRight: isFocusMode && '27px',
                                  justifyItems: 'center',
                                  gap: '5px',
                                  alignItems: 'center',
                                }}
                              >
                                {item?.isActive == 0 && (
                                  <Typography
                                    sx={{
                                      background: '#F939391A',
                                      color: '#F93939',
                                      borderRadius: '4px',
                                      fontSize: '12px',
                                      padding:
                                        item?.isConditional != 1
                                          ? '3px 15px'
                                          : '3px 8px',
                                      fontWeight: '600',
                                      fontFamily: 'poppins',
                                    }}
                                  >
                                    Withdrawn
                                  </Typography>
                                )}
                                <Typography
                                  sx={{
                                    background:
                                      item?.logIsConditional === 1 ||
                                      item?.isConditional == 1
                                        ? 'rgba(237, 11, 11, 0.6)'
                                        : 'rgba(16, 211, 94, 1)',
                                    color: 'white',
                                    borderRadius: '4px',
                                    fontSize: isFocusMode ? '10px' : '12px',
                                    padding: '2px 7px',
                                    fontWeight: '500',
                                    fontFamily: 'poppins',
                                    visibility:
                                      item?.isPrivate == 1 ||
                                      item?.isCounter == 1
                                        ? 'visible'
                                        : item?.buyerUniqueId ===
                                            userDetail?.userAppId &&
                                          item?.logIsConditional !== null
                                        ? 'visible'
                                        : 'hidden',
                                  }}
                                >
                                  {item?.logIsConditional == 1 ||
                                  item?.isConditional == 1
                                    ? 'Conditional'
                                    : ' Unconditional'}
                                </Typography>
                              </Grid>
                              <Grid
                                xs={6}
                                sm={3.3}
                                item
                                display="flex"
                                justifyContent={isFocusMode ? 'start' : 'right'}
                                marginRight={isFocusMode && '-20px'}
                              >
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins !important',
                                    fontStyle: 'normal !important',
                                    fontWeight: '600 !important',
                                    fontSize: isFocusMode
                                      ? '12px'
                                      : matchesmd
                                      ? '14px'
                                      : '20px',
                                    color:
                                      item?.isPrivate == 1 ||
                                      item?.isCounter == 1
                                        ? '#2F74EE'
                                        : index == firstActiveIndex
                                        ? '#6C2AD2'
                                        : 'black',
                                    marginTop: matchessm && '-10px',
                                  }}
                                >
                                  <OfferLeftTime>
                                    {item?.offerPrice != ''
                                      ? item?.offerPrice
                                      : '-'}
                                  </OfferLeftTime>
                                </Typography>
                                {buyerOffers?.length > 1 &&
                                  index == firstActiveIndex &&
                                  item?.propertyOfferBuyerId !== '0' && (
                                    <Typography
                                      sx={{
                                        position: 'absolute',
                                        right: '7px',
                                        top: '5px',
                                      }}
                                    >
                                      <BuyerhighestOffPin />
                                    </Typography>
                                  )}
                              </Grid>
                            </Grid>
                            {item?.isActive != 0 && (
                              <Typography sx={{ mr: '-12px' }}></Typography>
                            )}
                            {item?.isActive != 0 && (
                              <Typography
                                sx={{
                                  marginRight: '-12px',
                                  marginTop: '-20px',
                                  borderRadius: '50%',
                                  width: '30px',
                                  height: matchessm ? '25px' : '30px',
                                }}
                              >
                                {!sharedpage &&
                                  item?.buyerUniqueId ===
                                    userDetail?.userAppId &&
                                  stage == 'ST1' &&
                                  item?.lastOfferStatus != 'Private Offer' &&
                                  item?.lastOfferStatus != 'Counter Offer' &&
                                  item?.lastOfferStatus != 'Accepted' &&
                                  item?.lastOfferStatus != 'Rejected' &&
                                  getBuyerIndividualValue?.PropertyDetails
                                    ?.timerStatus == 'Start' &&
                                  isConditionalChanceCompleted != 1 && (
                                    <HighlightOff
                                      onClick={() =>
                                        offerSetFunc(
                                          item?.offerUniqueId,
                                          item?.offerPrice,
                                          item?.isAutoOffer
                                        )
                                      }
                                      sx={{
                                        color: 'grey',
                                        backgroundColor: '#ffff',
                                        borderRadius: '50%',
                                        cursor: 'pointer',
                                      }}
                                    />
                                  )}
                              </Typography>
                            )}
                          </Grid>
                          {/* </MakeofferRectangle> */}
                        </TableRow>
                      );
                    })}

                    {sharedpage && (
                      <TableRow>
                        <Button
                          variant="outlined"
                          style={{
                            height: matchessm ? '35px' : '41px',
                            fontSize: matchessm ? '12px' : '14px',
                            color: '#FFFFFF',
                            fontWeight: '400',
                            fontFamily: 'Poppins',
                            background: '#4CA4D6',
                            borderRadius: '5px',
                            textTransform: 'capitalize',
                          }}
                          onClick={() => {
                            setOpenlogin(!openlogin);
                          }}
                        >
                          Offer History
                        </Button>
                      </TableRow>
                    )}
                  </>
                ) : (
                  <TableRow
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      background: 'none',
                      alignItems: 'center',
                      marginTop: '7%',
                    }}
                  >
                    <Typography
                      sx={{
                        ...poppins500,
                        fontSize: '24px',
                        color: '#112347',
                        textAlign: 'center',
                        width: '100%',
                        fontWeight: '400 !important',
                      }}
                    >
                      No offers found
                    </Typography>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
          {sharedpage && (
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
              position="relative"
              sx={{
                width: '100%',
                textAlign: 'center',
                paddingTop: matchessm ? '70px' : '130px',
              }}
            >
              <Box>
                <LockIconSharePage />
              </Box>
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: '24px',
                  paddingTop: '30px',
                  color: '#112347',
                }}
              >
                Restricted
              </Typography>
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: '20px',
                  color: '#112347',
                }}
              >
                Please log in for full access.
              </Typography>
            </Stack>
          )}
        </Box>
        {lastHighestOffers?.length > 5 && !matchessm && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              background: isFocusMode && '#FFFFFF',
              paddingBottom: 2,
            }}
          >
            <Box
              sx={{
                width: 'fit-content',
                border: '1px solid lightgrey',
                padding: '5px',
                borderRadius: '5px',
                cursor: 'pointer',
                mr: 1.5,
                background: isFocusMode && '#FAFAFA',
              }}
            >
              <ExpandLessOutlined
                sx={{ color: '#666666' }}
                onClick={handleScrollToTopListing}
              />
            </Box>
          </Box>
        )}
      </Stack>
      {showpopup && (
        <MakeOffersNewPopup
          manageOfferData={manageOfferData}
          setManageOfferData={setManageOfferData}
          propertyId={propertyId}
          matches380={matches380}
          setOfferSummary={setOfferSummary}
          offerSummary={offerSummary}
          getBuyerIndividualValue={getBuyerIndividualValue}
          matchessm={matchessm}
          lastHighestOffers={lastHighestOffers}
          indexs={indexs}
          setShowpopup={setShowpopup}
          vendorCounterOffer={vendorCounterOffer}
          vendorCounterOfferValue={vendorCounterOfferValue}
          buyerOffers={buyerOffers}
        />
      )}
      <Dialog
        open={openWithdraw}
        // open={true}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '20px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Withdraw Offer
            </Typography>
          </Grid>
          <Grid item md={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
                marginTop: '50px',
              }}
            >
              You are withdrawing your offer of{' '}
              <span>
                {' '}
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    color: '#666666',
                  }}
                >
                  {withdrawOfferamount}
                </b>
              </span>
              . <br />
              Your offer will no longer be available to the Vendor for
              consideration.
              <br />
              <br />
              Frequently withdrawing offers can reduce your reputation with the
              Vendor and marketplace.
            </Typography>
          </Grid>
          <Grid item md={12} sx={{ marginTop: '20px' }}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '14px' : '18px',
                color: '#666666',
              }}
            >
              Withdraw left count :{' '}
              <Typography component="span">
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    color: '#666666',
                  }}
                >
                  {withdrawLeftCount}
                </b>
              </Typography>
            </Typography>
          </Grid>
          {isThisAutoOffer == 1 && (
            <Grid
              item
              container
              xs={12}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                border: '1px solid #f39800',
                backgroundColor: '#fef5e5',
                padding: 1,
                mt: '30px',
                alignItems: 'center',
                mr: '-30px',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}
            >
              <Grid
                item
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  pr: 0.5, // Use paddingRight for consistent minimal gap
                }}
              >
                <WarningIcon fontSize={isXsScreen ? 'small' : 'medium'} />
              </Grid>

              <Grid
                item
                sx={{
                  flex: 1,
                  overflow: 'hidden',
                  display: 'flex',
                  alignItems: 'center', // Align text vertically
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    color: '#666666',
                    fontSize: matchessm ? '9px' : '14px', // Responsive font size
                    whiteSpace: { xs: 'wrap', md: 'nowrap' },
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  Your auto-offer settings will be deleted if you withdraw this
                  offer
                </Typography>
              </Grid>
            </Grid>
          )}

          <Grid
            item
            container
            direction="row"
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? '15px' : 5}
          >
            <Grid item>
              <Button
                disabled={openWithdrawLoader}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
                onClick={() => setOpenWithdraw(false)}
              >
                {withdrawLeftCount < 1 ? 'Close' : 'Cancel'}
              </Button>
            </Grid>
            {withdrawLeftCount > 0 && (
              <Grid
                item
                sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <Button
                  variant="outlined"
                  style={{
                    padding: matchessm ? '6px 23px' : '10px 39px',
                    width: '100%',
                    height: matchessm ? '35px' : '41px',
                    fontSize: matchessm ? '12px' : '14px',
                    color: '#FFFFFF',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    background: '#4CA4D6',
                    borderRadius: '5px',
                    textTransform: 'capitalize',
                  }}
                  disabled={openWithdrawLoader}
                  onClick={withdrawFunc}
                >
                  Confirm
                </Button>
                {openWithdrawLoader && (
                  <img
                    alt="Logo"
                    src={Loading}
                    className="loaderImage"
                    style={{ height: '40px', width: '40px' }}
                  />
                )}
              </Grid>
            )}
          </Grid>
        </Grid>
      </Dialog>
      <CampaignRestrictedPopup
        open={openCampaignRestrictedPopup}
        setOpen={setOpenCampaignRestrictedPopup}
        agentBuyerBinderId={agentBuyerBinderId}
      />
    </>
  );
};

export default OffersSection;
